import creditPriceData from '../../assets/commodity_bonus';

function getCaInstallmentsNumber(index) {
  const baseScore = creditPriceData[index];
  const keys = Object.keys(baseScore);
  return keys;
}

function getCaCreditPriceMonth(index, totalPrice, installmentsNumber) {
  let total = 0;
  const baseScore = creditPriceData[index];
  const find = baseScore[installmentsNumber];
  if (find) {
    const scoreItem = find[0];
    const multipleValue = totalPrice / 10000;
    total = parseInt(scoreItem.monthPrice * multipleValue);
  }
  return total;
}

function getCaTotalCreditPrice(index, totalPrice, installmentsNumber) {
  let total = 0;
  const baseScore = creditPriceData[index];
  const find = baseScore[installmentsNumber];
  if (find) {
    const scoreItem = find[0];
    const multipleValue = totalPrice / 10000;
    const creditPriceMonth = parseInt(scoreItem.monthPrice * multipleValue);
    total = parseInt(installmentsNumber) * parseInt(creditPriceMonth);
  }
  return total;
}

export {
  getCaInstallmentsNumber,
  getCaCreditPriceMonth,
  getCaTotalCreditPrice
}


// WEBPACK FOOTER //
// ./src/pages/utils/CreditRuleTools.js